import { InvoiceProcessingToolPanel } from "../InvoiceProcessingToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceReadyToProcessList extends Layout {
    layoutInvoiceProcessingToolPanel: InvoiceProcessingToolPanel;
    panelSecondaryFilters: Panel;
    sourceBillingComments: DataSource;
    sourceInvoiceProcessingCache: DataSource;
    tableProcessing: Table;
}
